import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FacilitiesApi } from '../api/clients/facilities';
import isAllowedForFacility from '@/utility';

const FacilitySelect = ({
  value = '',
  onChange,
  placeholderKey = 'payments.filters.facilitiesPlaceholder',
  useFormsApi = true,
  apiParams = null,
  parentKey,
  childKey,
  permission,
}) => {
  const { t } = useTranslation();
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        let facilitiesData;
        if (useFormsApi) {
          facilitiesData = await FacilitiesApi.getFacilitiesForForms();
        } else {
          const result = await FacilitiesApi.getFacilities(apiParams);
          facilitiesData = result.data;
        }
        setFacilities(facilitiesData);
      } catch (error) {
        console.error('Error fetching facilities:', error);
        setFacilities([]);
      }
    };

    fetchFacilities();
  }, [useFormsApi, apiParams]);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div style={{ marginTop: 0, paddingBottom: 0 }}>
      <div className='custom-search-box'>
        <div
          className='custom-select'
          style={{ marginTop: 0, paddingBottom: 0 }}>
          <select
            className='full-width-elem'
            id='facilitySelect'
            value={value}
            style={{ height: '35px' }}
            onChange={handleChange}>
            <option value='' style={{ fontWeight: 'bold' }}>
              {t(placeholderKey)}
            </option>
            {facilities.map((item) => {
              const isAllowed = isAllowedForFacility({
                parentKey,
                childKey,
                permission,
                facilityId: item.id,
              });
              return (
                <option
                  value={item.id}
                  className='parent'
                  disabled={!isAllowed}
                  style={{ fontWeight: 'bold' }}
                  key={item.id}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <span className='search-icon'></span>
      </div>
    </div>
  );
};

export default FacilitySelect;
